export default __webpack_public_path__ + "static/media/Logo.8a5b388e.svg";